// extracted by mini-css-extract-plugin
export default {"modalDescription":"g_n810XClZvxTCmTk9MQ"};